import { onSnapshot, orderBy, query, where } from "firebase/firestore";
import React, { useState, useEffect, useContext } from "react";
import { ratesRef } from "../firebase";
import { AuthContext } from "./AuthProvider";

const RatesContext = React.createContext([]);

const RatesProvider = ({ children }) => {
  const [rates, setRates] = useState([]);
  const { userData } = useContext(AuthContext);

  useEffect(() => {
    if (!userData.uid) {
      return;
    }

    // Subscribe to Rates

    let q = query(
      ratesRef,
      orderBy("accessId", "asc"),
      where("createdBy", "in", userData.associatedAccounts)
    );

    const unSubFromRates = onSnapshot(q, (querySnapshot) => {
      const dbRates = [];
      querySnapshot.forEach((rate) => {
        dbRates.push(rate.data());
      });
      setRates(dbRates);
    });

    return () => {
      // console.log("unsubbing from rates");
      unSubFromRates();
    };
  }, [userData.associatedAccounts, userData.uid]);

  return (
    <RatesContext.Provider value={rates}>{children}</RatesContext.Provider>
  );
};

export { RatesProvider, RatesContext };
